module.exports = __webpack_public_path__ + "static/media/email-black.a79b914a.svg";